import { Controller } from "@hotwired/stimulus"

// Use this Stimulus controller to remove any element from the DOM
export default class extends Controller {

  static targets = ["form", "name", "email", "notes", "submit"];
  static values = {
    songVersionId: Number
  }

  connect() {
    this.boundOpenCustomizeForm = this.openCustomizeForm.bind(this)
    document.addEventListener("customize:form", this.boundOpenCustomizeForm);
  }
  
  disconnect() {
    document.removeEventListener("customize:form", this.boundOpenCustomizeForm);
  }

  submitHandler(e){
    e.preventDefault()
    const body = {
      sender_name: e.target[0].value,
      sender_email: e.target[1].value,
      notes: e.target[2].value
    }
    fetch(`/song_versions/${this.songVersionIdValue}/customize`, {
      method: "POST", 
      headers:{
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body)
    }).then(res => res.text())
    .then(async(html) => {
      await Turbo.renderStreamMessage(html)
    })
  }

  openCustomizeForm(event) {
    const { songVersionId } = event.detail;
    const modal = document.querySelector("[data-controller='modal']");
    if (modal) {
      const modalController = this.application.getControllerForElementAndIdentifier(modal, "modal");
      const openEvent = new CustomEvent("modal:open", { detail: { size: "small" } });
      modalController?.open(openEvent);
    }
    Turbo.visit(`/customize_form/${songVersionId}`, { frame: "active-modal-content" })
  }
}